export const V1_SET_RETURN_DATE = 'V1_SET_RETURN_DATE'

export default data => {
  return {
    type: V1_SET_RETURN_DATE,
    data,
  }
}
